<template>
  <section>
    <v-row v-if="label" class="my-0 ellipsis" no-gutters>
      <span class="_subtitleFormFont">{{ label }}:</span>
    </v-row>
    <div :class="['container-style', {'disabled': disabled}]">
      <div :class="['opt', {'isSelected': fontAlignment[keyValue] === 'left'}]" @click="handleSelectOption('left')">
        <v-icon size="16" :color="fontAlignment[keyValue] === 'left' ? 'bt_color' : ''">fa-solid fa-align-left</v-icon>
      </div>

      <div :class="['vertical-divider', {'someOptIsSelected': fontAlignment[keyValue] === 'left'}]"></div>
      <div :class="['opt', {'isSelected': fontAlignment[keyValue] === 'center'}]" @click="handleSelectOption('center')">
        <v-icon size="16" :color="fontAlignment[keyValue] === 'center' ? 'bt_color' : ''">fa-solid fa-align-center</v-icon>
      </div>

      <div :class="['vertical-divider', {'someOptIsSelected': fontAlignment[keyValue] === 'right'}]"></div>
      <div :class="['opt', {'isSelected': fontAlignment[keyValue] === 'right'}]" @click="handleSelectOption('right')">
        <v-icon size="16" :color="fontAlignment[keyValue] === 'right' ? 'bt_color' : ''">fa-solid fa-align-right</v-icon>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'FormAlignment',
  props: {
    value: {type: Object, required: true},
    keyValue: {type: String, default: 'alignment'},
    label: {type: String, required: false},
    disabled: {type: Boolean, default: false}
  },

  computed: {
    fontAlignment: {
      get () { return this.value },
      set (v) { 
        this.$emit('input', v)
      }
    }
  },

  methods: {
    handleSelectOption (value) {
      if (this.fontAlignment[this.keyValue] !== value) this.fontAlignment[this.keyValue] = value
      else this.fontAlignment[this.keyValue] = ''
    }
  }
}
</script>

<style scoped>
.container-style {
  display: flex;
  height: 40px;
  border-radius: 8px;
  background-color: #F6F7F7;
  cursor: pointer;
}

.disabled {
  pointer-events: none;
  opacity: 0.7;
}

.opt {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;  
  border: 1px solid #EDEDF1;
}

.opt:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 0;
}

.opt:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-left: 0;
}

.vertical-divider {
  height: 100%;
  width: 1px;
  background-color: #EDEDF1;
}

.vertical-divider.someOptIsSelected {
  background-color: #0067AF80;
}

.opt.isSelected {
  background-color: #E1F2FEB2;
  border-color: #0067AF80;
}

.ellipsis {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipsis span {
  overflow: hidden;
  text-overflow: ellipsis;  
}
</style>
